// extracted by mini-css-extract-plugin
export default {"nowrap":"TemplatesList_nowrap_OM2OR","deleted":"TemplatesList_deleted_Updes","actions":"TemplatesList_actions_Xy7mD","bold":"TemplatesList_bold_JmNP4"};